var _effectorFileName = "/builds/gmini/front-ui-kit/src/OfflineModal/model.ts";
import { createApi, createStore } from 'effector';
import { useStore } from 'effector-react';
export const online$ = createStore(window.navigator.onLine, {
  ɔ: {
    name: 'online'
  },
  name: "online$",
  sid: "alycp9"
});
export const connectionBroken$ = createStore(!window.navigator.onLine, {
  ɔ: {
    name: 'connectionBroken'
  },
  name: "connectionBroken$",
  sid: "l0isi4"
}).on(online$.updates.filter({
  fn: online => !online
}), () => true);
export const useOnline = () => useStore(online$);
export const useConnectionBroken = () => useStore(connectionBroken$);
export const {
  online,
  offline
} = createApi({
  ɔ: [online$, {
    online: () => true,
    offline: () => false
  }],
  config: {
    sid: "-7s5vfp"
  }
});
offline.watch(payload => console.error('Соединение потеряно!', payload));
window.addEventListener('online', online);
window.addEventListener('offline', offline);